import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = user
  const [token, setToken] = useState(localStorage.getItem("mis_token"));

  const loadMe = useCallback(async () => {
    const t = localStorage.getItem("mis_token");
    if (!t) {
      setUser(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("mis_token");
      setUser(false);
    }
  }, []);

  useEffect(() => {
    loadMe();
  }, [loadMe]);

  const login = useCallback((tok, u) => {
    localStorage.setItem("mis_token", tok);
    setToken(tok);
    setUser(u);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("mis_token");
    setToken(null);
    setUser(false);
  }, []);

  const refresh = useCallback(() => loadMe(), [loadMe]);

  return (
    <AuthContext.Provider value={{ user, token, login, logout, refresh, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
